module.exports = __webpack_public_path__ + "media/site_templates/www.plumbingservices.company/images/splash-04eec03cfe42f80f4ecf71c78545eee8.jpg";